import React, { ReactNode } from 'react';
import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';

interface ErrorMessageProps {
  condition: boolean;
  onClose: (...args: any[]) => any;
  action?: ReactNode;
  children: ReactNode | ReactNode[];
  className?: string;
}

export const ErrorMessage = ({
  condition,
  onClose,
  action,
  children,
  className,
}: ErrorMessageProps) => (
  <Collapse className={condition ? className : ''} in={condition}>
    <Alert
      severity="error"
      onClose={onClose}
      action={(
        <>
          {action}
          <IconButton
            style={{ marginLeft: '14px' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={onClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </>
      )}
    >
      {children}
    </Alert>
  </Collapse>
);
